import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';
import {
  faCheck,
  faCircleInfo,
  faCircleXmark,
  faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons';
import { FaIconComponent } from '../../atoms';
import { IconProp } from '@fortawesome/angular-fontawesome/types';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'orbit-message',
  standalone: true,
  imports: [FaIconComponent, ButtonComponent],
  templateUrl: './message.component.html',
  styleUrl: './message.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.error]': 'severity() === "error"',
    '[class.success]': 'severity() === "success"',
    '[class.info]': 'severity() === "info"',
    '[class.warning]': 'severity() === "warning"',
  },
})
export class MessageComponent {
  message = input.required<string>();
  title = input<string>();
  severity = input<'error' | 'warning' | 'info' | 'success'>('info');
  messageAddonLink = input<{ url: string; text: string } | null>(null);
  addonButtonIcon = input<IconProp | null>(null);
  titleTestId = input<string>();
  messageTestId = input<string>();
  onAddonButtonClick = output<void>();
  icon = computed(() => {
    const severity = this.severity();
    switch (severity) {
      case 'error':
        return faCircleXmark;
      case 'warning':
        return faTriangleExclamation;
      case 'info':
        return faCircleInfo;
      case 'success':
        return faCheck;
      default:
        return faCircleInfo;
    }
  });

  faCircleInfo = faCircleInfo;
  faTriangleExclamation = faTriangleExclamation;
  faCheck = faCheck;
  faCircleXmark = faCircleXmark;
  list = input<any[] | undefined>(undefined);
  listKey = input<string>('message');
}
